"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const EmptyElements_styles_1 = require("./EmptyElements.styles");
const EmptyElements = ({ numElements, maxElements, showEmpty }) => {
    const emptyCards = react_1.default.useMemo(() => {
        const max = maxElements ? maxElements - numElements : numElements;
        return new Array(Math.min(Math.max(0, max), showEmpty)).fill(null);
    }, [numElements, maxElements, showEmpty]);
    return (react_1.default.createElement(react_1.default.Fragment, null, emptyCards.map((_, idx) => (react_1.default.createElement(EmptyElements_styles_1.EmptyListItem, { role: "presentation", key: idx })))));
};
exports.default = EmptyElements;
//# sourceMappingURL=EmptyElements.js.map